/**
 * Created by Jonas Wålekvist on 2018-10-10.
 */
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {Ease, Power2, Timeline} from "gsap";
import {IAdjacentBetLineWinData} from "../../utils/SymbolUtil";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildGameMode} from "../features/DirtyWildsRespinZeroBetController";
import {DirtyWildsModeData} from "../server/data/DirtyWildsModeData";
import {DirtyWildsStateReelSymbol, DirtyWildsSymbols} from "../symbols/DirtyWildsStateReelSymbol";
import {DirtyWildsReelController} from "./DirtyWildsReelController";

export class DirtyWildReelPartAnimator extends SpinReelPartAnimator {

    set isRandomFeatureReelStop(value:boolean) {
        this._isRandomFeatureReelStop = value;
    }

    set isRandomSyncReelStop(value:boolean) {
        this._isRandomSyncReelStop = value;
    }

    set currentReelId(value:number) {
        this._currentReelId = value;
    }

    private _isRandomFeatureReelStop:boolean;
    private _isRandomSyncReelStop:boolean;
    private _currentReelId:number;
    private wildSpinBy:number = 0;

    constructor(reelId:number) {
        super(reelId);
    }

    private powerEaseIn(t:number, d:number, pow:number) {
        return Math.pow(t / d, pow);
    }

    private powerEaseOut(t:number, d:number, pow:number) {
        return 1 - Math.pow(1 - (t / d), pow);
    }

    private ease(time:number, startValue:number, changeValue:number, totalDuration:number, pow:number) {
        return changeValue * time / totalDuration + startValue;
    }

    public setupTweenSpinSpeedQueue(endSpeed:number, steps:number):void {
        this._spinSpeedsQueue = [];

        for(let i:number = 0; i < steps; i++) {
            this._spinSpeedsQueue.push(this.spinSpeed + (endSpeed - this.spinSpeed) * this.powerEaseIn(i, steps - 1, 3));
        }
        this.spinSpeed = this._spinSpeedsQueue.pop()!;
        this._spinSpeedsQueue.push(this.spinSpeed);
    }

    private getEaseForSpin():any {
        let allowedReelId = this._isRandomFeatureReelStop ? [2] : [1, 2, 3];
        let easeTime:number = (<any>this).spinSpeed * 3;
        let customEase:any = Power2.easeOut;
        if(allowedReelId.indexOf(this._currentReelId) > -1) {
            if(this._isRandomFeatureReelStop) {
                let symbol:DirtyWildsStateReelSymbol | null = null;
                if(this._symbolsToAnimate.length > 0) {
                    symbol = <DirtyWildsStateReelSymbol>this._symbolsToAnimate[0];
                }
                if(symbol !== null && !symbol.controller.isQuickStop()) {
                    customEase = CustomEase.create('custom', 'M0,0 C0.09,0.178 0.244,0.49 0.272,0.561 0.333,0.717 0.438,0.95 0.456,1 0.464,0.985 0.485,1.109 0.566,1.11 0.658,1.11 0.636,1.102 0.652,1.098 0.742,1.03 0.719,0.981 0.726,0.998 0.788,1.108 0.835,1.078 0.859,1.078 0.88,1.078 0.897,0.985 0.911,0.998 0.922,0.994 0.939,1.022 0.954,1.022 0.969,1.022 1,1 1,1');
                }
            }
        }
        return {ease : customEase, easeTime : easeTime};
    }

    private dimEdgeReels() {
        for(var i = 0; i < this._symbolsToAnimate.length; i++) {
            let symbol:DirtyWildsStateReelSymbol = <DirtyWildsStateReelSymbol>this._symbolsToAnimate[i];
            if(symbol == null) {
                continue;
            }
            if(symbol.controller._isRandomFeatureTriggered && (symbol.controller.reelId === 0 || symbol.controller.reelId === 4)) {
                symbol.changeState({
                    state : DirtyWildsGameConfig.instance.SYMBOL_STATES.randomObslete,
                    fadeInDuration : 0
                });
            }
        }
    }

    private sameWinningSymbol(symbol:DirtyWildsStateReelSymbol, betWin:IAdjacentBetLineWinData):boolean {
        let symbolReelController:DirtyWildsReelController = symbol.controller;
        let symbolsToStop:DirtyWildsStateReelSymbol[] = symbolReelController.getStopSymbols();
        const symIndex:number = symbolsToStop.indexOf(symbol);
        return (symbolsToStop.length > 0 && symIndex === betWin.betLine[betWin.lineStart === "Left" ? 0 : 4]);
    }

    protected fadeOutSymbolBlur():void {
        for(let i:number = 0; i < this._symbolsToAnimate.length; i++) {
            let symbol:DirtyWildsStateReelSymbol = <DirtyWildsStateReelSymbol>this._symbolsToAnimate[i];
            let symbolReelController:DirtyWildsReelController = symbol.controller;
            if(!symbolReelController.isQuickStop() && symbolReelController._isRandomSyncFeatureTriggered && (symbolReelController.reelId === 0 || symbolReelController.reelId === 4)) {
                if(symbolReelController._betWins.length > 0) {
                    for(let i = 0; i < symbolReelController._betWins.length; i++) {
                        const betWin = <IAdjacentBetLineWinData>symbolReelController._betWins[i];
                        if(symbol.symName === betWin.symbol && this.sameWinningSymbol(symbol, betWin) && ((betWin.lineStart === "Left" && symbolReelController.reelId === 0) || (betWin.lineStart === "Right" && symbolReelController.reelId === 4))) {
                            symbol.changeState({
                                state : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE ? GameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE() : GameConfig.instance.SYMBOL_STATES.normal,
                                replay : false,
                                fadeInDuration : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION,
                                fadeInDelay : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY
                            });
                        }
                    }
                }
            } else if(symbolReelController.isQuickStop() || !(symbolReelController._isRandomFeatureTriggered && (symbolReelController.reelId === 0 || symbolReelController.reelId === 4))) {
                symbol.changeState({
                    state : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE ? GameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE() : GameConfig.instance.SYMBOL_STATES.normal,
                    replay : false,
                    fadeInDuration : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION,
                    fadeInDelay : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY
                });
            }
        }
        this._isRandomFeatureReelStop = false;
        this._isRandomSyncReelStop = false;
    }

    public getSpinAnimation(newSymbol:StateReelSymbol):Timeline {
        const tl:Timeline = super.getSpinAnimation(newSymbol);
        tl.add(() => {
            if(DirtyWildsModeData.instance.mode == DirtyWildGameMode.STICKY_RESPIN) {
                if(this._symbolsToAnimate[0].symName == DirtyWildsSymbols.W) {
                    let soundToBePlayed:string = DirtyWildsSoundConfig.WILD_SPIN_BY1;
                    switch(this.wildSpinBy) {
                        case 1:
                            soundToBePlayed = DirtyWildsSoundConfig.WILD_SPIN_BY2;
                            break;
                        case 2:
                            soundToBePlayed = DirtyWildsSoundConfig.WILD_SPIN_BY3;
                            break;
                        case 3:
                            soundToBePlayed = DirtyWildsSoundConfig.WILD_SPIN_BY4;
                            break;
                    }
                    SlotGame.sound.playEffect(soundToBePlayed);
                    this.wildSpinBy = this.wildSpinBy === 3 ? 0 : (this.wildSpinBy + 1);
                }
            }
        }, 0);
        return tl;
    }

    protected calculationStopSpinSpeed():number {
        if(this._isRandomFeatureReelStop || this._isRandomSyncReelStop) {
            let customEase:any = this.getEaseForSpin();
            return (this._spinSpeedsQueue && this._spinSpeedsQueue.length > 0) ? this._spinSpeedsQueue.shift()! : customEase.easeTime;
        }
        return super.calculationStopSpinSpeed();
    }

    protected getSpinStopEase():Ease {
        if(this._isRandomFeatureReelStop || this._isRandomSyncReelStop) {
            let customEase:any = this.getEaseForSpin();
            return customEase.ease;
        }
        return super.getSpinStopEase();
    }

    protected getSpinQuickStopEase():Ease {
        if(this._isRandomFeatureReelStop || this._isRandomSyncReelStop) {
            let customEase:any = this.getEaseForSpin();
            return customEase.ease;
        }
        return super.getSpinQuickStopEase();
    }
}